import React, { forwardRef } from 'react';
import './Card.less';

/**
 * Card — canonical elevated surface.
 *
 * Tone variants introduce a small hierarchy so a page doesn't render
 * as a stack of identical rectangles:
 *   - `default` : white/dark surface, 1px border, subtle shadow.
 *   - `hero`    : slightly larger radius, generous padding, soft
 *                 brand-tint gradient in the top-right corner. Used
 *                 once per page for the primary anchor.
 *   - `subtle`  : muted surface, no shadow. Used for helper panels
 *                 (Quick Start, tips) that should sit calmer than
 *                 the actionable cards around them.
 */
const Card = forwardRef(function Card(
  {
    as: Tag = 'div',
    className = '',
    interactive = false,
    tone = 'default',
    ...rest
  },
  ref,
) {
  return (
    <Tag
      ref={ref}
      className={
        `gc-card gc-card-tone-${tone}` +
        (interactive ? ' is-interactive' : '') +
        (className ? ` ${className}` : '')
      }
      {...rest}
    />
  );
});

export default Card;
